const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID?.trim();
const VALID_MEASUREMENT_ID = /^G-[A-Z0-9]+$/i;

let lastPageViewKey = "";

function hasValidMeasurementId() {
  return Boolean(GA_MEASUREMENT_ID && VALID_MEASUREMENT_ID.test(GA_MEASUREMENT_ID));
}

export function initializeAnalytics() {
  if (typeof window === "undefined" || !hasValidMeasurementId()) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };

  if (!document.querySelector(`script[data-google-tag="${GA_MEASUREMENT_ID}"]`)) {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_MEASUREMENT_ID)}`;
    script.dataset.googleTag = GA_MEASUREMENT_ID;
    document.head.appendChild(script);
  }

  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID, { send_page_view: false });
}

export function trackPageView(path, title) {
  if (typeof window === "undefined" || typeof window.gtag !== "function" || !hasValidMeasurementId()) return;

  const pageViewKey = `${path}:${title}`;
  if (lastPageViewKey === pageViewKey) return;
  lastPageViewKey = pageViewKey;

  window.gtag("event", "page_view", {
    page_title: title,
    page_location: new URL(path, window.location.origin).href,
  });
}
